import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'overlay',
  template: `<div><ng-content></ng-content></div>`,
  styleUrls: ['./overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayComponent {}
